import * as React from 'react';
import {FC, ReactNode} from 'react';
import classNames from 'classnames';

import './Layout.sass';


interface ILayoutProps {
    TabBar: ReactNode;
    List: ReactNode;
    Header: ReactNode;
    Thread: ReactNode;
    Input: ReactNode;
    Account: ReactNode;
    TopBar: ReactNode;

    minimized: boolean;
    accountExpanded: boolean;
    loading: boolean;
}


export const Layout: FC<ILayoutProps> = (props) => (
    <div
        className={classNames('mvc', 'mvc-layout-wrapper', {
            ['minimized']: props.minimized,
            ['account-expanded']: props.accountExpanded,
            ['loading']: props.loading,
        })}
    >
        <div className={'mvc-layout-top-bar'}>{props.TopBar}</div>
        <div className={'mvc-layout-tab-bar'}>{props.TabBar}</div>
        <div className={'mvc-layout-header'}>{props.Header}</div>
        <div className={'mvc-layout-thread'}>{props.Thread}</div>
        <div className={'mvc-layout-input'}>{props.Input}</div>
        <div className={'mvc-layout-list'}>{props.List}</div>
        <div className={'mvc-layout-account'}>{props.Account}</div>
    </div>
);
